<template>
  <edit-modal
    :is-show-dialog="isShowDialog"
    :action-label="actionLabel"
    :title="dialogTitle"
    @on-close="onClose"
    @on-action="onAction"
  >
    <v-overlay
      :absolute="true"
      :value="isModalLoading"
    >
      <v-progress-circular indeterminate size="24"></v-progress-circular>
    </v-overlay>
    <v-form
      ref="form"
      autocomplete="off"
      method="post"
      action=""
    >
      <input autocomplete="false" name="hidden" type="text" style="display:none;">
      <input type="search"/>
      <v-container>
        <v-row
          v-model="valid"
          :lazy-validation="true"
        >
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="editableObject.name"
              :counter="200"
              :rules="[rules.required, rules.max(200)]"
              :label="lang($store, 'sap/listings.global.filter.hints.name')"
              prepend-icon="mdi-account-badge-outline"
              required
              autocomplete="off"
              :error-messages="(errors && errors.name)?errors.name:null"
              @input="removeError('name')"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <field-phone
              v-model="editableObject.phone"
              :rules="[rules.required, rules[initPhoneRule]]"
              :error-messages="(errors && errors.phone)?errors.phone:null"
              @input="removeError('phone')"
            ></field-phone>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="editableObject.email"
              :counter="200"
              :rules="[rules.max(200), rules.email]"
              prepend-icon="mdi-email"
              :label="lang($store, 'sap/listings.global.filter.hints.email')"
              type="email"
              required
              autocomplete="off"
              :error-messages="(errors && errors.email)?errors.email:null"
              @input="removeError('email')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="editableObject.password"
              :counter="50"
              :rules="isCreation
              ?[rules.max(50), rules.min(6)]
              :[rules.max(50), rules.min(6)]"
              prepend-icon="mdi-lock-question"
              :append-icon="showPass ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
              :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"
              :label="lang($store, 'sap/listings.global.filter.hints.password')"
              :hint="lang($store, 'sap/listings.global.filter.hints.password_live_empty')"
              persistent-hint
              autocomplete="new-password"
              :error-messages="(errors && errors.password)?errors.password:null"
              @input="removeError('password')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="3"
          >
            <v-select
              v-model="editableObject.role"
              :items="rolesItems"
              prepend-icon="mdi-briefcase-account"
              single-line
              :hint="lang($store, 'sap/listings.global.filter.hints.role')"
              persistent-hint
              :error-messages="(errors && errors.role)?errors.role:null"
              @change="removeError('role')"
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="3"
          >
            <v-select
              v-model="editableObject.roles"
              :items="roleItemsWithoutMain"
              prepend-icon="mdi-briefcase-account"
              single-line
              multiple
              :hint="lang($store, 'sap/listings.global.filter.hints.roles')"
              persistent-hint
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="3"
          >
            <v-switch
              v-model="editableObject.active"
              class="ma-4"
              :false-value="0"
              :true-value="1"
              :label="lang($store, 'sap/listings.global.filter.hints.active')"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-switch
              v-model="editableObject.has_inventory"
              class="ma-4"
              :label="lang($store, 'sap/listings.global.filter.hints.has_inventory')"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-dialog
              ref="dialogStart"
              v-model="modalCarierStart"
              :return-value.sync="editableObject.carier_start_at"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editableObject.carierString"
                  :label="lang($store, 'sap/listings.global.filter.hints.carier_start_at')"
                  prepend-icon="mdi-calendar"
                  readonly
                  :error-messages="(errors && errors.carier_start_at)?errors.carier_start_at:null"
                  @input="removeError('carier_start_at')"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="editableObject.carierFormattedISO"
                locale="ru"
                :first-day-of-week="1"
                scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="modalCarierStart = false">
                  {{ lang($store, 'sap/buttons.cancel') }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogStart.save(
                    moment(editableObject.carierFormattedISO, DATE_ISO)
                  )">
                  {{ lang($store, 'sap/buttons.ok') }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-if="ranksItems"
              v-model="editableObject.rank"
              :items="ranksItems"
              prepend-icon="mdi-chevron-triple-up"
              single-line
              :hint="lang($store, 'sap/listings.global.filter.hints.rank')"
              persistent-hint
              :error-messages="(errors && errors.rank)?errors.rank:null"
              @change="removeError('rank')"
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="editableObject.note"
              :counter="200"
              :rules="[rules.max(200)]"
              prepend-icon="mdi-tooltip-text-outline"
              :label="lang($store, 'sap/listings.global.filter.hints.note')"
              autocomplete="off"
              :error-messages="(errors && errors.note)?errors.note:null"
              @input="removeError('note')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <div style="display: flex;">
              <v-select
                style="width: 50%"
                v-model="editableObject.card_text"
                :items="banks"
                prepend-icon="mdi-credit-card"
                single-line
                :hint="lang($store, 'sap/listings.global.filter.hints.bank')"
                persistent-hint
                :error-messages="(errors && errors.card_text)?errors.card_text:null"
                @change="removeError('card_text')"
              ></v-select>
              <v-text-field
                v-model="editableObject.card_number"
                :counter="200"
                :rules="[rules.max(200)]"
                :label="lang($store, 'sap/listings.global.filter.hints.card_number')"
                autocomplete="off"
                :error-messages="(errors && errors.card_number)?errors.card_number:null"
                @input="removeError('card_number')"
                v-mask="'#### #### #### ####'"
              ></v-text-field>
            </div>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="editableObject.address"
              :counter="200"
              :rules="[rules.max(200)]"
              prepend-icon="mdi-home-city-outline"
              :label="lang($store, 'sap/listings.global.filter.hints.address')"
              autocomplete="off"
              :error-messages="(errors && errors.address)?errors.address:null"
              @input="removeError('address')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="editableObject.region"
              :items="cleanerRegionsItems"
              prepend-icon="mdi-map-marker"
              single-line
              :hint="lang($store, 'sap/listings.global.filter.hints.region')"
              persistent-hint
              :error-messages="(errors && errors.region)?errors.region:null"
              @change="removeError('region')"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <avatar-selector
              v-model="editableObject.new_avatar"
              :url="editableObject.avatar"
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-textarea
              v-model="editableObject.additional_info"
              :counter="3000"
              :rules="[rules.max(3000)]"
              prepend-icon="mdi-account-badge-horizontal-outline"
              :label="lang($store, 'sap/listings.global.filter.hints.additional_info')"
              autocomplete="off"
              :error-messages="(errors && errors.additional_info)?errors.additional_info:null"
              @input="removeError('additional_info')"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </edit-modal>
</template>

<script>
import moment from 'moment';
/* constants */
import { mask } from 'vue-the-mask';
import regionsFilter from '@/mixins/filters/regionsFilter';
import cleanerRegionsFilter from '@/mixins/filters/regionsCleanersFilter';

import {
  MANAGER_BASE,
  MANAGER_COMPLEX,
  CLEANER_BASE,
  CLEANER_COMPLEX, FOREMAN,
} from '../../constants/roles';
import * as ranks from '../../constants/ranks';
import { DATE_ISO, DATE_VIEW } from '../../constants/dates';
import { REGIONS } from '~constants/region';
/* utils */
import { deepMerge, cloneObj } from '../../utils';
/* mixins */
import editModalMixin from '../../mixins/editModalMixin';
import validationMixin from '../../mixins/validationMixin';
import phoneMixin from '@/mixins/phoneMixin';
/* components */
import EditModal from './EditModal.vue';
import FieldPhone from '../text-fields/FieldPhone.vue';
import AvatarSelector from '../image-fields/AvatarSelector.vue';
import i18n from '@/i18n';


export default {
  name: 'EditModalCleaner',
  directives: { mask },
  mixins: [
    editModalMixin,
    validationMixin,
    regionsFilter,
    cleanerRegionsFilter,
    phoneMixin,
  ],
  components: {
    EditModal,
    FieldPhone,
    AvatarSelector,
  },
  props: {
    item: {
      type: Object,
      default: () => {
      },
    },
    errors: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      moment,
      DATE_ISO,
      modalCarierStart: false,
      ranks,
      /* validation */
      showPass: false,
      /* Data */
      initialEditableObject: {
        name: '',
        phone: '',
        active: 1,
        has_inventory: false,
        role: MANAGER_BASE,
        roles: [],
        region: REGIONS.kyiv,
        carier_start_at: null,
        carierString: null,
        carierFormattedISO: null,
      },
      editableObject: {},
      banks: [
        '',
        i18n.t('enums.banks.privatbank'), // 'Приватбанк',
        i18n.t('enums.banks.monobank'), // 'Монобанк',
        i18n.t('enums.banks.oschadbank'), // 'Ощадбанк',
        i18n.t('enums.banks.ukreximbank'), // 'Укрэксимбанк',
        i18n.t('enums.banks.raiffeisen'), // 'Райффайзен',
        i18n.t('enums.banks.pumb'), // 'ПУМБ',
        i18n.t('enums.banks.alfabank'), // 'АльфаБанк',
      ],
    };
  },
  mounted() {
    this.initEditableObject();
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    isCreation() {
      return !(this.item.name);
    },
    dialogTitle() {
      return this.isCreation ? this.item.name : '';
    },
    ranksItems() {
      if (this.editableObject.role === CLEANER_BASE) {
        const items = [];
        Object.keys(ranks)
          .forEach(key => {
            items.push({
              text: this.lang(this.$store, `sap/listings.global.filter.ranks.${ranks[key]}`),
              value: ranks[key],
            });
          });
        return items;
      }

      return null;
    },
    rolesItems() {
      switch (this.account.role) {
        case MANAGER_BASE:
          return [
            {
              text: this.lang(this.$store, 'sap/listings.global.filter.roles.cleaner_base'),
              value: CLEANER_BASE,
            },
          ];
        case MANAGER_COMPLEX:
          return [
            {
              text: this.lang(this.$store, 'sap/listings.global.filter.roles.cleaner_complex'),
              value: CLEANER_COMPLEX,
            },
            {
              text: this.lang(this.$store, 'sap/listings.global.filter.roles.foreman'),
              value: FOREMAN,
            },
          ];
        default:
          return [
            {
              text: this.lang(this.$store, 'sap/listings.global.filter.roles.cleaner_base'),
              value: CLEANER_BASE,
            },
            {
              text: this.lang(this.$store, 'sap/listings.global.filter.roles.cleaner_complex'),
              value: CLEANER_COMPLEX,
            },
            {
              text: this.lang(this.$store, 'sap/listings.global.filter.roles.foreman'),
              value: FOREMAN,
            },
          ];
      }
    },
    roleItemsWithoutMain() {
      // const currentMainItems = this.rolesItems;
      return this.rolesItems.filter(role => this.editableObject.role !== role.value);
    },
  },
  watch: {
    isShowDialog(newVal) {
      if (newVal) {
        this.initEditableObject();
        this.resetValidation();
      }
    },
    'editableObject.carier_start_at': {
      handler(newVal) {
        if (newVal) {
          this.editableObject.carierFormattedISO = moment(newVal)
            .format(DATE_ISO);
          this.editableObject.carierString = moment(newVal)
            .format(DATE_VIEW);
        }
      },
      deep: true,
    },
  },
  methods: {
    initEditableObject() {
      switch (this.account.role) {
        case MANAGER_COMPLEX:
          this.initialEditableObject.role = CLEANER_COMPLEX;
          break;
        default:
          this.initialEditableObject.role = CLEANER_BASE;
          break;
      }
      this.editableObject = deepMerge(cloneObj(this.initialEditableObject), this.item);
      if (this.item.carier_start_at === undefined) {
        this.editableObject.carier_start_at = moment();
        this.editableObject.carierString = moment()
          .format(DATE_VIEW);
      }
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onAction() {
      if (this.$refs.form.validate()) {
        this.$emit('on-action', this.editableObject);
      }
    },
    removeError(key) {
      if (this.errors && this.errors[key]) {
        this.errors[key] = null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>

</style>
